export default "__VITE_ASSET__BowE2kL3__"